"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = Tag;
var _core = require("@blueprintjs/core");
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _classes = require("../../common/classes");
var _Icon = require("../icon/Icon");
var _Tooltip = require("../tooltip/Tooltip");
var _excluded = ["children", "className", "colorFamily", "condensed", "disabled", "maxWidth", "muted", "onClick", "onRemove", "outline", "small", "rightIcon", "truncated"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function Tag(_ref) {
  var children = _ref.children,
    className = _ref.className,
    colorFamily = _ref.colorFamily,
    condensed = _ref.condensed,
    disabled = _ref.disabled,
    maxWidth = _ref.maxWidth,
    muted = _ref.muted,
    onClick = _ref.onClick,
    onRemove = _ref.onRemove,
    outline = _ref.outline,
    small = _ref.small,
    rightIconProp = _ref.rightIcon,
    truncated = _ref.truncated,
    tagProps = _objectWithoutProperties(_ref, _excluded);
  var defaultProps = {
    round: true
  };

  /**
   * I don't really know why there's a boolean check here but i'm too scared to remove it
   */
  var icon = tagProps.icon;
  if (icon == null || typeof icon === 'boolean') {
    icon = null;
  } else if (typeof icon === 'string') {
    icon = /*#__PURE__*/React.createElement(_Icon.Icon16, {
      icon: icon
    });
  }

  /**
   * For the right icon treat any string as an 8px icon name
   * Allow anything else through (for now)
   */
  var rightIcon;
  if (typeof rightIconProp === 'string') {
    rightIcon = /*#__PURE__*/React.createElement(_Icon.Icon8, {
      icon: rightIconProp
    });
  } else {
    rightIcon = rightIconProp;
  }
  var baseClasses = (0, _classnames.default)(_classes.Classes.colorFamilyClass(colorFamily), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _classes.Classes.CONDENSED, condensed), _classes.Classes.MUTED, muted), _classes.Classes.OUTLINE, outline), _classes.Classes.SMALL, small), _classes.Classes.DISABLED, disabled), className);

  /**
   * For disabled tags we need to remove the onClick handler and onRemove handlers
   */
  var sharedTagProps = _objectSpread(_objectSpread(_objectSpread({}, defaultProps), tagProps), {}, {
    icon: icon,
    rightIcon: rightIcon,
    'aria-disabled': disabled,
    onClick: disabled ? undefined : onClick,
    onRemove: disabled ? undefined : onRemove
  });
  var regularTag = /*#__PURE__*/React.createElement(_core.Tag, _extends({
    className: baseClasses
  }, sharedTagProps), children);

  /**
   * Tooltips can only really take strings as content
   */
  if (typeof children === 'string') {
    if (condensed) {
      /**
       * Don't show any text if we have an icon
       */
      var showTooltip = !!icon;
      var content = icon ? undefined : children;
      if (showTooltip) {
        return /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
          content: children
        }, /*#__PURE__*/React.createElement(_core.Tag, _extends({
          className: baseClasses
        }, sharedTagProps), content));
      }
      /*#__PURE__*/React.createElement(_core.Tag, _extends({
        className: baseClasses
      }, sharedTagProps), content);
    }

    /**
     * Always show the Tooltip as there's no easy way of telling if the tag will be truncated or not.
     */
    if (truncated || maxWidth) {
      var tagWidth = maxWidth || 120;
      var styles = _objectSpread(_objectSpread({}, tagProps.style), {}, {
        maxWidth: "".concat(tagWidth, "px")
      });
      return /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
        content: children
      }, /*#__PURE__*/React.createElement(_core.Tag, _extends({
        className: baseClasses
      }, sharedTagProps, {
        style: styles
      }), children));
    }
  }
  return regularTag;
}